import { render, staticRenderFns } from "./ManuscriptPreviewPage.vue?vue&type=template&id=a0a61bac&scoped=true"
import script from "./ManuscriptPreviewPage.vue?vue&type=script&lang=ts"
export * from "./ManuscriptPreviewPage.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptPreviewPage.vue?vue&type=style&index=0&id=a0a61bac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a61bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0a61bac')) {
      api.createRecord('a0a61bac', component.options)
    } else {
      api.reload('a0a61bac', component.options)
    }
    module.hot.accept("./ManuscriptPreviewPage.vue?vue&type=template&id=a0a61bac&scoped=true", function () {
      api.rerender('a0a61bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ManuscriptPreviewPage.vue"
export default component.exports